/**
 * Web mock for React Native Share
 * Provides web-compatible sharing functionality
 */

class Share {
  static async share(content, options = {}) {
    const { message, title, url } = content;
    
    // Use Web Share API if available (mobile browsers and some desktop)
    if (navigator.share) {
      try {
        await navigator.share({
          title: title || 'Praise Devotion',
          text: message,
          url: url,
        });
        
        return { action: 'sharedAction' };
      } catch (error) {
        if (error.name === 'AbortError') {
          return { action: 'dismissedAction' };
        }
        throw error;
      }
    }
    
    // Fallback: copy to clipboard and show instructions
    if (navigator.clipboard && message) {
      try {
        await navigator.clipboard.writeText(message);
        alert('Content copied to clipboard! You can now paste it anywhere to share.');
        return { action: 'sharedAction' };
      } catch (error) {
        console.error('Failed to copy to clipboard:', error);
      }
    }
    
    // Final fallback: open in new window for email/social media
    const shareText = encodeURIComponent(message || '');
    const shareTitle = encodeURIComponent(title || 'Praise Devotion');
    
    // Create a simple share modal
    const shareOptions = [
      {
        name: 'Email',
        url: `mailto:?subject=${shareTitle}&body=${shareText}`,
      },
      {
        name: 'Twitter',
        url: `https://twitter.com/intent/tweet?text=${shareText}`,
      },
      {
        name: 'Facebook',
        url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}&quote=${shareText}`,
      },
      {
        name: 'WhatsApp',
        url: `https://wa.me/?text=${shareText}`,
      },
      {
        name: 'Copy Text',
        action: () => {
          // Fallback copy method
          const textArea = document.createElement('textarea');
          textArea.value = message;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
          alert('Text copied to clipboard!');
        },
      },
    ];
    
    // Create modal
    this.showShareModal(shareOptions);
    
    return { action: 'sharedAction' };
  }
  
  static showShareModal(options) {
    // Create modal overlay
    const overlay = document.createElement('div');
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10000;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    `;
    
    // Create modal content
    const modal = document.createElement('div');
    modal.style.cssText = `
      background: white;
      border-radius: 12px;
      padding: 24px;
      max-width: 400px;
      width: 90%;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    `;
    
    // Add title
    const title = document.createElement('h3');
    title.textContent = 'Share Devotion';
    title.style.cssText = `
      margin: 0 0 20px 0;
      color: #333;
      font-size: 18px;
      font-weight: 600;
    `;
    modal.appendChild(title);
    
    // Add share options
    options.forEach(option => {
      const button = document.createElement('button');
      button.textContent = option.name;
      button.style.cssText = `
        width: 100%;
        padding: 12px;
        margin: 8px 0;
        border: 1px solid #ddd;
        border-radius: 8px;
        background: white;
        color: #333;
        font-size: 16px;
        cursor: pointer;
        transition: all 0.2s;
      `;
      
      button.addEventListener('mouseenter', () => {
        button.style.background = '#f5f5f5';
      });
      
      button.addEventListener('mouseleave', () => {
        button.style.background = 'white';
      });
      
      button.addEventListener('click', () => {
        if (option.action) {
          option.action();
        } else if (option.url) {
          window.open(option.url, '_blank');
        }
        document.body.removeChild(overlay);
      });
      
      modal.appendChild(button);
    });
    
    // Add cancel button
    const cancelButton = document.createElement('button');
    cancelButton.textContent = 'Cancel';
    cancelButton.style.cssText = `
      width: 100%;
      padding: 12px;
      margin: 16px 0 0 0;
      border: none;
      border-radius: 8px;
      background: #f5f5f5;
      color: #666;
      font-size: 16px;
      cursor: pointer;
    `;
    
    cancelButton.addEventListener('click', () => {
      document.body.removeChild(overlay);
    });
    
    modal.appendChild(cancelButton);
    
    // Close on overlay click
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        document.body.removeChild(overlay);
      }
    });
    
    overlay.appendChild(modal);
    document.body.appendChild(overlay);
  }
}

export default Share;
